import { MODAL_TYPE_POST_SETTINGS } from '@wix/communities-blog-client-common';
import { openModal } from '../../modals/framework/store/modal-actions';
import { getWriters } from '../../selectors/writers-selectors';
import { getCategories } from '../categories/categories-selectors';

export const openPostSettings =
  ({ activeTab, formInitialValues, postValues, isPublished, postId, canPublish }) =>
  (dispatch, getState) =>
    dispatch(
      openModal(MODAL_TYPE_POST_SETTINGS, {
        activeTab,
        canPublish,
        categories: getCategories(getState()),
        formInitialValues,
        isPublished,
        postId,
        postValues,
        writers: getWriters(getState()),
      }),
    );
